import { createContext, useContext } from "react";
import { CurrentUser } from "../../types/User";
import { Layer } from "../../types/Layer";

interface AuthContextType {
  user: CurrentUser | undefined;
  login: (user: CurrentUser) => void;
  logout: (redirectBack?: boolean) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const useAuthContext = () => {
  // get the context
  const context = useContext(AuthContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error("useAuthContext was used outside of its Provider");
  }

  return context;
};

export { AuthContext, useAuthContext };
